import React from "react";

import { UniformEntryPageProps } from "../../../../pages/uniform-entry/uniform-entry-page";
import { UniformWrapper } from "../../../../uniform/uniform-wrapper";

export const UniformEntryPageTemplate: React.FC<UniformEntryPageProps> = ({
    composition,
    isUniformPlayground
}) => {
    return (
        <UniformWrapper
            composition={composition}
            isUniformPlayground={isUniformPlayground}
        />
    );
};
